import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

import { ApplicationSettings } from '@core/settings/application.settings';

export interface IAppSettings {

	ApiBaseUrl: string,
	Application?: ApplicationSettings
}

@Injectable({
	providedIn: 'root'
})
export class AppSettingsService {
	settings: Observable<Readonly<IAppSettings>>;

	private settingsSource: BehaviorSubject<IAppSettings> = new BehaviorSubject<
		IAppSettings
	>({
		ApiBaseUrl: '',
		Application: undefined
	});

	constructor() {
		this.settings = this.settingsSource.asObservable();
	}

	setSettings(settings: Partial<IAppSettings>) {

		const updatedConfig = {
			...this.settingsSource.value,
			...settings
		};

		this.settingsSource.next(updatedConfig);
	}

	getSettings(): Readonly<IAppSettings> {

		return this.settingsSource.value;
	}
}